import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { adminRoutes } from './Data'
import AdminNavigation from '../components/navigation/AdminNavigation'
import Error404 from '../components/error/Error404'

const AdminRoutes = () => {
    return (
        <Routes>
            <Route element={<AdminNavigation />}>
                {adminRoutes.map(({ path, element }, index) => (
                    <Route key={index} path={path} element={element} />
                ))}
                <Route path="*" element={<Navigate to="/dashboard/data" />} />
            </Route>
        </Routes>
    )
}

export default AdminRoutes